import api from './api';

export interface Tenant {
  id: number;
  nomTenant: string;
  chaineConnexion: string;
  apiKey: string;
  dateCreation: string;
  dateModification?: string;
  disabled?: boolean;
}

export interface CreateTenantRequest {
  nomTenant: string;
  chaineConnexion: string;
}

export const tenantService = {
  // Récupérer tous les tenants
  getAllTenants: async (): Promise<Tenant[]> => {
    const response = await api.get('/api/tenants');
    return response.data;
  },

  // Récupérer un tenant par ID
  getTenantById: async (id: number): Promise<Tenant> => {
    const response = await api.get(`/api/tenants/${id}`);
    return response.data;
  },

  // Créer un nouveau tenant
  createTenant: async (tenant: CreateTenantRequest): Promise<Tenant> => {
    const response = await api.post('/api/tenants', tenant);
    return response.data;
  },

  // Mettre à jour un tenant
  updateTenant: async (id: number, tenant: CreateTenantRequest): Promise<Tenant> => {
    const response = await api.put(`/api/tenants/${id}`, tenant);
    return response.data;
  },

  // Supprimer un tenant
  deleteTenant: async (id: number): Promise<void> => {
    await api.delete(`/api/tenants/${id}`);
  },

  // Régénérer la clé API
  regenerateApiKey: async (id: number): Promise<{ apiKey: string }> => {
    const response = await api.post(`/api/tenants/${id}/regenerate-apikey`);
    return response.data;
  },

  // Activer/Désactiver un tenant
  toggleTenantStatus: async (id: number): Promise<Tenant> => {
    const response = await api.patch(`/api/tenants/${id}/toggle-status`);
    return response.data;
  }
};

